import { FC } from "react";
import { Alert, Box, Grid2 as Grid } from "@mui/material";
import ResidencyForm from "@components/ResidencyForm/ResidencyForm";
import { useFieldArray, UseFormReturn } from "react-hook-form";
import TextIconButton from "@components/TextIconButton";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import { PersonFormType } from "@utils/patientFormHelper";

const ResidenciesForm: FC<{
  form: UseFormReturn<PersonFormType>;
}> = ({ form }) => {
  const { t } = useTranslation();
  const { control } = form;

  const {
    fields: residencyFields,
    append: appendResidency,
    remove: removeResidency,
    update: updateResidency,
  } = useFieldArray<PersonFormType, "residencies">({
    control,
    name: "residencies",
    keyName: "_id" as any,
  });

  const addResidency = (): void => {
    appendResidency({
      id: undefined,
      location: undefined,
      startDate: undefined,
      endDate: undefined,
    });
  };

  const deleteResidency = (index: number): void => {
    const residency = residencyFields[index];
    if (!residency) {
      return;
    }
    if (!residency.id) {
      removeResidency(index);
    } else {
      updateResidency(index, { ...residency, delete: true });
    }
  };

  return (
    <>
      <Alert variant="standard" severity="info" color="info">
        {t("personForm.residencyDescription")}
      </Alert>
      <Grid container spacing={2} marginTop="16px">
        <Grid size={12}>
          <Grid container spacing={{ xs: 5, md: 2 }}>
            {residencyFields.map((field, index) => {
              if (field.delete) {
                return "";
              }
              return (
                <Grid size={12} key={field._id}>
                  <ResidencyForm
                    index={index}
                    form={form}
                    onDeleteRow={deleteResidency}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <TextIconButton
              iconLeft={true}
              variant="outlined"
              text={t("personForm.addResidencyButton")}
              icon={AddIcon}
              color="primary"
              onClick={addResidency}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ResidenciesForm;
